<template>
    <div>
        <line-chart 
            :headerTitle="progress_total_execution_chart.headerTitle"
            :headingSize="progress_total_execution_chart.headingSize" 
            :chartSeries="progress_total_execution_chart.chartSeries" 
            :lineData="progress_total_execution_chart.lineData"
            :chartLegend="progress_total_execution_chart.chartLegend"
            :chartLoaded="progress_total_execution_chart.chartLoaded"
        >
        </line-chart>

        <double-bar-chart 
            :headerTitle="progress_current_available.headerTitle" 
            :headingSize="progress_current_available.headingSize"
            :chartSeries="progress_current_available.chartSeries"
            :chartxAxis="progress_current_available.chartxAxis"
            :chartLegend="progress_current_available.chartLegend"
            :chartLoaded="progress_current_available.chartLoaded"
        >
        </double-bar-chart>
    </div>
</template>

<script>
import Vue from 'vue';
import http from '@/libs/http';
import LineChart from '@/components/pages/project/percent_progress/common/charts/line_chart.vue';
import DoubleBarChart from '@/components/pages/project/percent_progress/common/charts/double_bar_chart.vue';

export default {
    name: 'targets_and_current_progress_overview_piping_value',
    components: {
        LineChart,
        DoubleBarChart,
    },
    props: {
        rowData: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            //Progress from Total Execution Value estimated
            progress_total_execution_chart: {
                headerTitle: Vue.i18n.translate('general.projects.progress.progress_total_execution_chart.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.percent_progress_targets_work_value'), //step_detail_calculation_work_value
                        type: 'line',
                        symbolSize: 8,
                        data: [],
                        color: '#4a7ebb',
                    },
                    {
                        name: Vue.i18n.translate('table.percent_ist_progress_total_work_value_calculation'),
                        type: 'line',
                        symbolSize: 8,
                        data: [],
                        color: '#8b71ab',
                    },
                    {
                        name: Vue.i18n.translate('table.percent_ist_progress_total_work_value_status'),
                        type: 'line',
                        symbolSize: 8,
                        data: [],
                        color: '#5bb4cb',
                    },
                    {
                        name: Vue.i18n.translate('table.recovery_1_percent_progress_targets_work_value'), //recovery_1_step_detail_calculation_work_value
                        type: 'line',
                        symbolSize: 8,
                        data: [],
                        color: '#c55e5b',
                    },
                    {
                        name: Vue.i18n.translate('table.recovery_2_percent_progress_targets_work_value'), //recovery_2_step_detail_calculation_work_value
                        type: 'line',
                        symbolSize: 8,
                        data: [],
                        color: '#9ebc5f',
                    }
                ],
                chartSeriesAvailable: [
                    'percent_progress_targets_work_value',
                    'percent_ist_progress_total_work_value_calculation',
                    'percent_ist_progress_total_work_value_status',
                    'recovery_1_percent_progress_targets_work_value',
                    'recovery_2_percent_progress_targets_work_value',
                ],
                lineData: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.percent_progress_targets_work_value'),
                    },
                    {
                        name: Vue.i18n.translate('table.percent_ist_progress_total_work_value_calculation'),
                    },
                    {
                        name: Vue.i18n.translate('table.percent_ist_progress_total_work_value_status'),
                    },
                    {
                        name: Vue.i18n.translate('table.recovery_1_percent_progress_targets_work_value'),
                    },
                    {
                        name: Vue.i18n.translate('table.recovery_2_percent_progress_targets_work_value'),
                    },
                ],
                chartLoaded: false,
            },

            //Progress from Current Available Execution Value
            progress_current_available: {
                headerTitle: Vue.i18n.translate('general.projects.progress.progress_current_available_chart.title'),
                headingSize: 'h4',
                chartSeries: [
                    {
                        name: Vue.i18n.translate('table.percent_peformed_from_available_work_value_calculation'),
                        type: 'bar',
                        data: []
                    },
                    {
                        name: Vue.i18n.translate('table.percent_peformed_from_available_work_value_status'),
                        type: 'bar',
                        data: []
                    }
                ],
                chartSeriesAvailable: [
                    'percent_peformed_from_available_work_value_calculation',
                    'percent_peformed_from_available_work_value_status'
                ],
                chartxAxis: [],
                chartLegend: [
                    {
                        name: Vue.i18n.translate('table.percent_peformed_from_available_work_value_calculation'),
                    },
                    {
                        name: Vue.i18n.translate('table.percent_peformed_from_available_work_value_status'),
                    },
                ],
                chartLoaded: false,
            },
        }
    },
    mounted () {
        this.onLoadChart1();
        this.onLoadChart2();
    },
    methods: {
        onLoadChart1 () {
            this.rowData.forEach((field, idx) => {
                this.progress_total_execution_chart.lineData.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.progress_total_execution_chart.chartSeriesAvailable[0] === key) {
                        that.progress_total_execution_chart.chartSeries[0].data.push(field[key]);
                    }
                    
                    if (that.progress_total_execution_chart.chartSeriesAvailable[1] === key) {
                        that.progress_total_execution_chart.chartSeries[1].data.push(field[key]);
                    }

                    if (that.progress_total_execution_chart.chartSeriesAvailable[2] === key) {
                        that.progress_total_execution_chart.chartSeries[2].data.push(field[key]);
                    }

                    if (that.progress_total_execution_chart.chartSeriesAvailable[3] === key) {
                        that.progress_total_execution_chart.chartSeries[3].data.push(field[key]);
                    }

                    if (that.progress_total_execution_chart.chartSeriesAvailable[4] === key) {
                        that.progress_total_execution_chart.chartSeries[4].data.push(field[key]);
                    }
                });
            });
            
            this.progress_total_execution_chart.chartLoaded = (this.rowData.length > 0);
        },
        onLoadChart2 () {
            this.rowData.forEach(field => {
                this.progress_current_available.chartxAxis.push(field.step_calendar);
                var that = this;
                
                Object.keys(field).forEach(function(key) {
                    if (that.progress_current_available.chartSeriesAvailable[0] === key) {
                        that.progress_current_available.chartSeries[0].data.push(field[key]);
                    }
                    
                    if (that.progress_current_available.chartSeriesAvailable[1] === key) {
                        that.progress_current_available.chartSeries[1].data.push(field[key]);
                    }
                });
            });

            this.progress_current_available.chartLoaded = (this.rowData.length > 0);
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/piping_value/targets_and_current_progress_overview/targets_and_current_progress_overview_charts_piping_value.vue